// extracted by mini-css-extract-plugin
export default {"page":"BalancePage_page__TgV9-"};